// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

  /**
   * @class M.Model.ProductDetails.ZoomDialog
   */
  M.Model.ProductDetails.ZoomDialog = Backbone.Model.extend({
    defaults: {
      sku: null,
      title: null,
      shapeOptions: {},
      colorOptions: {},
      greetingOptions: {},
      orientation: null,
      photoViewOptions: {},
      accessoryOptions: {},
      accessoriesPricingDict: {},
      isPythonPDPPanel: false,
      appendFlatShape: true
    },

    initialize: function() {
      M.required(this.get('accessoryData'));
      M.required(this.get('colorData'));
      M.required(this.get('orientation'));
      M.required(this.get('photoViewData'));
      M.required(this.get('shapeData'));
      M.required(this.get('sku'));
      M.required(this.get('title'));

      var that = this;

      // Shape Options
      var shapeOptions = new M.Collection.ProductDetails.Shapes();

      // First insert a flat card option (no die cut)
      var flatCard = new M.Model.ProductDetails.Shape({
        id: 0,
        code: null,
        name: 'default',
        orientation: that.get('orientation')
      });

      // Ornament cards do not have a flat shape!
      // TODO: Move this to data if this comes up alot.
      if (!M.SKU.isOrnamentSku(this.get('sku')) && !M.SKU.isCustomSticker(this.get('sku')) && this.get('appendFlatShape')) {
        shapeOptions.add(flatCard);
      }

      _.each(this.get('shapeData'), function(shape) {
        var shapeOption = new M.Model.ProductDetails.Shape({
          id: shape.id,
          name: shape.name,
          code: shape.code,
          // Orientation is required to get the correct
          // css class, TODO: refactor out.
          orientation: that.get('orientation')
        });
        shapeOptions.add(shapeOption);
      });
      this.set({'shapeOptions': shapeOptions});

      // Color Options
      var colorOptions = new M.Collection.ProductDetails.Colors();
      var firstColorLetter = 'Z';
      _.each(this.get('colorData'), function(color, idx) {
        var colorOption = new M.Model.ProductDetails.Color({
          id: color.id,
          rgb: color.color_rgb,
          name: color.colorway_name,
          letter: color.letter,
          foilColor: color.foil_color,
          displayFoilSwatch: color.display_foil_swatch
        });
        if (firstColorLetter != 'A' && color.letter < firstColorLetter) {
          firstColorLetter = color.letter;
        }
        colorOptions.add(colorOption);
      });
      this.set({'colorOptions': colorOptions});

      // View Options
      this.updatePhotoViewOptions(this.get('photoViewData'));

      // Greeting Options
      var greetingOptions = new M.Collection.ProductDetails.Greetings();
      _.each(this.get('greetingData'), function(greeting, idx) {
        var greetingModel = new M.Model.ProductDetails.Greeting(greeting);
        greetingOptions.add(greetingModel);
      });
      var selectedGreetingId = this.get('selectedGreetingId');
      if (selectedGreetingId) {
        greetingOptions.select(greetingOptions.get(selectedGreetingId));
      }
      this.set({'greetingOptions': greetingOptions});

      // Accessory Options
      var accessoriesPricingDict = {};
      var accessoryOptions = new M.Collection.ProductDetails.Accessories();
      _.each(this.get('accessoryData'), function(accessoryDict) {
        // Create a ProductOptionsPricing model for each accessory and
        // store it in a dictionary mapping from sku to ProductOptionsPricing
        // model for that product.
        var accessorySku = accessoryDict['product_sku'];
        var accessoryOptionsPricing = new
          M.Model.ProductDetails.ProductOptionsPricing({
            isAccessory: true,
            priceMap: accessoryDict['price_map'],
            defaultQuantity: 0,
            productSku: accessorySku,
            urlParams: {},
            formatOptionList: accessoryDict['formats']
          });
        accessoriesPricingDict[accessorySku] = accessoryOptionsPricing;

        // Build a list of accessories for use in the UI
        var accessoryOption = new M.Model.ProductDetails.Accessory({
          id: accessoryDict['id'],
          description: accessoryDict['product_kind_description'],
          sku: accessoryDict['product_sku'],
          url: accessoryDict['pdp_url']
        });
        accessoryOptions.add(accessoryOption);
      });

      this.set({'accessoriesPricingDict': accessoriesPricingDict});
      this.set({'accessoryOptions': accessoryOptions});

      // Keeps track of the image selection
      var productImage = new M.Model.ProductImage({
        sku: this.get('sku'),
        photoCode: M.PRODUCT_IMAGE.PHOTO_CODE.PZ,
        viewCode: M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE,
        colorCode: firstColorLetter,
        dieCutCode: this.get('selectedDieCutCode'),
        colorChoiceId: 1,
        showBacker: false
      });

      var selectedGreeting = greetingOptions.getSelected();
      if (selectedGreeting) {
        productImage.set({
          greetingIndex: selectedGreeting.get('id'),
          greeting: selectedGreeting.get('displayName')
        });
      }

      this.set({'productImage': productImage});
    },

    /**
     * Returns a list of Accessory.skus.
     *
     * @return accessorySkus {List}
     */
    getAccessorySkus: function() {
      var accessorySkus = [];
      var accessoryOptions = this.get('accessoryOptions').models;
      _.each(accessoryOptions, function(accessory) {
        accessorySkus.push(accessory.get('sku'));
      });
      return accessorySkus;
    },

    updatePhotoViewOptions: function(photoViewData) {
      var photoViewOptions = new M.Collection.ProductDetails.PhotoViews();
      _.each(photoViewData, function(photo) {
        if (photo.file_photo_code) {
          var photoView = new M.Model.ProductDetails.PhotoView({
            id: photo.id,
            code: photo.file_photo_code,
            description: photo.description
          });
          photoViewOptions.add(photoView);
        }
      });

      this.set({'photoViewOptions': photoViewOptions});
    }
  });
